import { Component, VERSION } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from "../../../../../environments/environment";
import { ButtonDirective } from 'primeng/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'no-access',
    templateUrl: './no-access.component.html',
    styleUrls: ['./no-access.component.css'],
    imports: [ButtonDirective, TranslatePipe],
})
export class NoAccessComponent {

	readonly url = environment.aps_request_url;
	readonly isConnectionError: boolean;
	version = VERSION.full;
	location: Pick<Location, 'href' | 'replace' | 'reload'> = globalThis.location;

	constructor(route: ActivatedRoute) {
		this.isConnectionError = route.snapshot.queryParamMap.get('reason') === 'connection';
	}

	retry(): void {
		// Full reload resets the in-memory user so the auth guard runs checkAccess again
		const url = new URL(this.location.href);
		url.search = '';
		url.hash = '/home-page';
		this.location.replace(url.toString());
		this.location.reload();
	}
}

